module.exports = __webpack_public_path__ + "img/logo-debt-solution.3d8e43ba.svg";